export default `/* Ids Pager Input Component */
:host(ids-pager-input) {
  display: inline-flex;
  align-items: center;
}

.ids-pager-input,
ids-input::part(container) {
  margin-inline-start: var(--ids-space-2xs);
  margin-inline-end: var(--ids-space-2xs);
  margin-block-end: 0;
}

.ids-pager-input input,
ids-input::part(input) {
  padding-block-start: 0;
  padding-block-end: 0;
  margin-block-end: 0;
  min-width: var(--ids-space-xl);
}

.ids-pager-input label,
ids-input::part(label) {
  margin-block-end: 0;
  height: 0;
}

.ids-pager-input,
ids-input::part(field-container) {
  margin-block-end: 0;
}

ids-text {
  margin-inline-start: var(--ids-space-2xs);
  margin-inline-end: var(--ids-space-2xs);
}

ids-input[size=xs]::part(field-container),
.ids-input.xs .field-container {
  width: auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtcGFnZXIiLCJzb3VyY2VzIjpbImlkcy1wYWdlci1pbnB1dC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBQ0E7RUFDRTtFQUNBOzs7QUFHRjtBQUFBO0VBRUU7RUFDQTtFQUNBOzs7QUFHRjtBQUFBO0VBRUU7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0FBQUE7RUFFRTtFQUNBOzs7QUFHRjtBQUFBO0VBRUU7OztBQUdGO0VBQ0U7RUFDQTs7O0FBSUY7QUFBQTtFQUVFIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIFBhZ2VyIElucHV0IENvbXBvbmVudCAqL1xuOmhvc3QoaWRzLXBhZ2VyLWlucHV0KSB7XG4gIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuXG4uaWRzLXBhZ2VyLWlucHV0LFxuaWRzLWlucHV0OjpwYXJ0KGNvbnRhaW5lcikge1xuICBtYXJnaW4taW5saW5lLXN0YXJ0OiB2YXIoLS1pZHMtc3BhY2UtMnhzKTtcbiAgbWFyZ2luLWlubGluZS1lbmQ6IHZhcigtLWlkcy1zcGFjZS0yeHMpO1xuICBtYXJnaW4tYmxvY2stZW5kOiAwO1xufVxuXG4uaWRzLXBhZ2VyLWlucHV0IGlucHV0LFxuaWRzLWlucHV0OjpwYXJ0KGlucHV0KSB7XG4gIHBhZGRpbmctYmxvY2stc3RhcnQ6IDA7XG4gIHBhZGRpbmctYmxvY2stZW5kOiAwO1xuICBtYXJnaW4tYmxvY2stZW5kOiAwO1xuICBtaW4td2lkdGg6IHZhcigtLWlkcy1zcGFjZS14bCk7XG59XG5cbi5pZHMtcGFnZXItaW5wdXQgbGFiZWwsXG5pZHMtaW5wdXQ6OnBhcnQobGFiZWwpIHtcbiAgbWFyZ2luLWJsb2NrLWVuZDogMDtcbiAgaGVpZ2h0OiAwO1xufVxuXG4uaWRzLXBhZ2VyLWlucHV0LFxuaWRzLWlucHV0OjpwYXJ0KGZpZWxkLWNvbnRhaW5lcikge1xuICBtYXJnaW4tYmxvY2stZW5kOiAwO1xufVxuXG5pZHMtdGV4dCB7XG4gIG1hcmdpbi1pbmxpbmUtc3RhcnQ6IHZhcigtLWlkcy1zcGFjZS0yeHMpO1xuICBtYXJnaW4taW5saW5lLWVuZDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG59XG5cbi8vIFJlbW92ZSBhdXRvbWF0aWMgd2lkdGggb24gXCJ4c1wiLXNpemVkIHBhZ2VyIGlucHV0c1xuaWRzLWlucHV0W3NpemU9J3hzJ106OnBhcnQoZmllbGQtY29udGFpbmVyKSxcbi5pZHMtaW5wdXQueHMgLmZpZWxkLWNvbnRhaW5lciB7XG4gIHdpZHRoOiBhdXRvO1xufVxuIl19 */`;
